module.exports = __webpack_public_path__ + "static/media/column-unactive.c4b20c50.svg";